// extracted by mini-css-extract-plugin
export default {"container":"App_container__BC+3N","app":"App_app__8qu7d","footerNote":"App_footerNote__-kZ2p","luv":"App_luv__uuiUG"};